// extracted by mini-css-extract-plugin
export var h1 = "footer-module--h-1--3j_7f";
export var h2 = "footer-module--h-2--2u5nt";
export var h3 = "footer-module--h-3--3jS2T";
export var genHeader = "footer-module--gen-header--1rdzk";
export var title = "footer-module--title--3Zgg5";
export var p1 = "footer-module--p-1--3BEiA";
export var p2 = "footer-module--p-2--1kYVJ";
export var p3 = "footer-module--p-3--3N47L";
export var container = "footer-module--container--3anUK";
export var titleContainer = "footer-module--title-container--3Atyy";
export var linkGroupsContainer = "footer-module--link-groups-container--3t-Vz";
export var linkGroup = "footer-module--link-group--3TlNG";
export var subtitle = "footer-module--subtitle--1fkuD";
export var linkCategory = "footer-module--link-category--1z75a";
export var linksContainer = "footer-module--links-container--1mwUz";
export var link = "footer-module--link--2tGs2";